import { Row, Table } from "react-bootstrap";

import classes from "../../purchase.module.scss";
import OrdersDeliveryTableHead from "./OrdersDeliveryTableHead";
import OrdersDeliveryTableBody from "./OrdersDeliveryTableBody";

const OrdersDeliveryTable = ({ data, setData, base, setBase }) => {
	return (
		<Row className={classes.table}>
			<Table className={classes.table_desktop}>
				<OrdersDeliveryTableHead base={base} setBase={setBase} />
				<OrdersDeliveryTableBody data={data} setData={setData} base={base} />
			</Table>
		</Row>
	);
};

export default OrdersDeliveryTable;
